@for (credential of renewalAvailableCredentials; track credential) {
  <section class="page-section credential-section">
    <div class="mt-1 header-row">
      <div class="header-text">
        <h3 class="credential-name">{{ credential.credentialName }}</h3>
        <span class="ml-1">
          <svg width="10" height="10">
            <circle
              class="status-dot Green"
              cx="5"
              cy="5"
              r="4"
              stroke-width="0"
            />
          </svg>
          Due
        </span>
        @if (!credential.canBeRenewedInPortal) {
          <p class="renewal-not-available">
            Please contact customer support to renew this credential.
          </p>
        }
        @if (credential.canBeRenewedInPortal) {
          <p>You can now begin the renewal process!</p>
        }
      </div>
      <button
        [disabled]="!credential.canBeRenewedInPortal || renewalStarted"
        mat-flat-button
        color="primary"
        class="mb-1"
        (click)="
          credential.lineupFromSecureLinkId
            ? continueRenewal(credential.lineupFromSecureLinkId)
            : startRenewal(credential.personCredentialId)
        "
      >
        {{
          !credential.lineupFromSecureLinkId
            ? 'Begin Renewal'
            : 'Continue Renewal'
        }}
      </button>
    </div>
  </section>
}
